import { useSyncExternalStore } from 'react'

/** Brian's desktop starts at 900px wide (desktop-nav.js: the frame is wider than 900). */
export const DESKTOP_QUERY = '(min-width: 900px)'

function subscribe(cb: () => void) {
  const mq = window.matchMedia(DESKTOP_QUERY)
  mq.addEventListener('change', cb)
  return () => mq.removeEventListener('change', cb)
}

export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribe, () => window.matchMedia(DESKTOP_QUERY).matches, () => false)
}
